import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_p3ekksgz4k: FaireBrandEntity = {
  token: "b_p3ekksgz4k",
  type: "brand",
  name: "Mama Bear Mahjong",
  avatarUrl:
    "https://cdn.faire.com/fastly/63291ffc1c89e033d842f541f8fc185cc6c416abb952d5db6c8e6edd4d7ab2cb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b7d253e308141454b933a6acccb1ddfa194537be7cf2f3390885221e4deccf6c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/63291ffc1c89e033d842f541f8fc185cc6c416abb952d5db6c8e6edd4d7ab2cb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b7d253e308141454b933a6acccb1ddfa194537be7cf2f3390885221e4deccf6c.jpeg",
  location: "Waco, TX, USA",
  minimumOrderDollars: 60,
  rating: 5,
  reviewCount: 1,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Mahjong with Mama Bear Mahjong—where timeless tradition meets thoughtful design. What began as a love for the game has grown into a curated collection of elevated essentials, each created to enhance the playing experience. From meaningful details to beautiful craftsmanship, every piece is designed to bring style, connection, and joy to the table. \n\nHere’s to beautiful games and even better memories!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:45.925Z",
    importedBy: "entity-db-cli",
  },
};
